// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Message, Icon } from 'semantic-ui-react';

/**
 * Google-specific UX hint shown above the credentials form. Phase 2 ships
 * SSO-only scopes (openid email profile) which DON'T require Google's app
 * verification when the OAuth consent screen is set to "Internal" — the
 * recommended path for Phase 2 pilots.
 *
 * "External" + sensitive scopes triggers a 4-6 week verification process
 * that's only relevant for Phase 7 (Calendar/Email) and is documented in
 * the brokerage IT runbook. This component just nudges the brokerage to
 * pick the right consent screen type up front.
 */
function ConsentScreenCallout() {
  return (
    <Message info>
      <Message.Header>
        <Icon name="info circle" />
        Recommend "Internal" OAuth consent screen type
      </Message.Header>
      <p>
        For Phase 2 (Google SSO only), tell brokerage IT to set the OAuth
        consent screen to <b>Internal</b> in Google Cloud Console. This:
      </p>
      <ul style={{ marginTop: 8 }}>
        <li>Skips Google's 4–6 week app verification process</li>
        <li>Limits the OAuth client to users in the brokerage's own Workspace tenant — exactly what we want for advisor SSO</li>
        <li>Allows future Phase 7 (Calendar / Email) scopes without re-running verification</li>
      </ul>
      <p style={{ marginTop: 8, marginBottom: 0 }}>
        If the brokerage needs <b>External</b> (e.g., advisors on personal Google
        accounts), point them at the brokerage Google OAuth runbook — but expect
        a verification delay if you plan to enable Calendar / Email in Phase 7.
      </p>
    </Message>
  );
}

export default ConsentScreenCallout;
